import { FC } from 'react';
import { CatIconHelp } from '@blocks-react/components/Icons/Help';
import { CatUtilityNavItem } from '@blocks-react/components/UtilityNavItem';
import { CatPrimaryNavItem } from '@blocks-react/components/PrimaryNavItem';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';

interface SubheaderHelpCenterProps {
  href?: string;
  label: string;
  displayMobileNavLink?: boolean;
  isTargetBlank?: boolean;
  isCurrent?: boolean;
}

export const SubheaderHelpCenter: FC<SubheaderHelpCenterProps> = ({
  href,
  label,
  displayMobileNavLink = false,
  isTargetBlank = false,
  isCurrent
}) => {
  return displayMobileNavLink ? (
    <CatPrimaryNavItem
      text={label}
      href={href}
      data-testId="help-center-item-mobile"
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={MAIN_NAV_TRACK.HELP_CENTER_TEXT}
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
      target={isTargetBlank ? '_blank' : '_self'}
      isCurrent={isCurrent}
      style={{
        borderBottom: '1px solid var(--cat-theme-color-border-strong-hover)'
      }}
    >
      <CatIconHelp data-testId="icon-help" slot="before" />
    </CatPrimaryNavItem>
  ) : (
    <CatUtilityNavItem
      text={label}
      href={href}
      data-testid="help-center-item-desktop"
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={MAIN_NAV_TRACK.HELP_CENTER_TEXT}
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
      target={isTargetBlank ? '_blank' : '_self'}
      isCurrent={isCurrent}
      aria-label={`${label} link opens a new tab`}
      role="menu"
    >
      <CatIconHelp data-testId="icon-help" slot="before" />
    </CatUtilityNavItem>
  );
};
